MaterialMenu.prototype.CssClasses_.MAX_HEIGHT = 'mdl-menu--window-height';

/**
 * Displays the menu.
 *
 * @public
 */
MaterialMenu.prototype.show = function(evt) {
    if (this.element_ && this.container_ && this.outline_) {

        const rect = this.element_.getBoundingClientRect();
        const maxHeight = document.documentElement.clientHeight;

        // Measure the inner element.
        var height = rect.height;
        var width = rect.width;

        // Hier wird noch abgefragt ob das Menü grösser als das Fenster ist, falls ja wird ein Scrollbalken eingesetzt
        if((rect.top + rect.height) > maxHeight && this.element_.classList.contains(this.CssClasses_.MAX_HEIGHT)) {
            height = document.documentElement.clientHeight - rect.top - 20;

            this.element_.style.overflow = 'auto';
            this.element_.style.height = '100%';
            this.element_.style.width = '100%';
            this.element_.style.padding = '0';
        }

        // Falls das Menü links über den Rand läuft, wird die Breite eingegrenzt (rechts braucht man das nicht zu tun, da die Breite des Dokument automatisch angepasst wird und man nach rechts scrollen kann)
        if(rect.left < 0 && (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT) || this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT))) {
            width += rect.left;
        }

        // Apply the inner element's size to the container and outline.
        this.container_.style.width = width + 'px';
        this.container_.style.height = height + 'px';
        this.outline_.style.width = width + 'px';
        this.outline_.style.height = height + 'px';

        var transitionDuration = this.Constant_.TRANSITION_DURATION_SECONDS *
            this.Constant_.TRANSITION_DURATION_FRACTION;

        // Calculate transition delays for individual menu items, so that they fade
        // in one at a time.
        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
        for (var i = 0; i < items.length; i++) {
            var itemDelay = null;
            if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT) ||
                this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
                itemDelay = ((height - items[i].offsetTop - items[i].offsetHeight) /
                    height * transitionDuration) + 's';
            } else {
                itemDelay = (items[i].offsetTop / height * transitionDuration) + 's';
            }
            items[i].style.transitionDelay = itemDelay;
        }

        // Apply the initial clip to the text before we start animating.
        this.applyClip_(height, width);

        // Wait for the next frame, turn on animation, and apply the final clip.
        // Also make it visible. This triggers the transitions.
        window.requestAnimationFrame(function() {
            this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
            this.element_.style.clip = 'rect(0 ' + width + 'px ' + height + 'px 0)';
            this.container_.classList.add(this.CssClasses_.IS_VISIBLE);
        }.bind(this));

        // Clean up after the animation is complete.
        this.addAnimationEndListener_();

        // Add a click listener to the document, to close the menu.
        var callback = function(e) {
            // Check to see if the document is processing the same event that
            // displayed the menu in the first place. If so, do nothing.
            // Also check to see if the menu is in the process of closing itself, and
            // do nothing in that case.
            // Also check if the clicked element is a menu item
            // if so, do nothing.
            if (e !== evt && !this.closing_ && e.target.parentNode !== this.element_) {
                document.removeEventListener('click', callback);
                this.hide();
            }
        }.bind(this);
        document.addEventListener('click', callback);
    }
};
MaterialMenu.prototype['show'] = MaterialMenu.prototype.show;

/**
 * Calculates the initial clip (for opening the menu) or final clip (for closing
 * it), and applies it. This allows us to animate from or to the correct point,
 * that is, the point it's aligned to in the "for" element.
 *
 * @param {number} height Height of the clip rectangle
 * @param {number} width Width of the clip rectangle
 * @private
 */
MaterialMenu.prototype.applyClip_ = function(height, width) {
    if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
        // Do not clip.
        this.element_.style.clip = '';
    } else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
        // Clip to the top right corner of the menu.
        this.element_.style.clip =
            'rect(0 ' + width + 'px ' + '0 ' + width + 'px)';
    } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
        // Clip to the bottom left corner of the menu.
        this.element_.style.clip =
            'rect(' + height + 'px 0 ' + height + 'px 0)';
    } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
        // Clip to the bottom right corner of the menu.
        this.element_.style.clip = 'rect(' + height + 'px ' + width + 'px ' +
            height + 'px ' + width + 'px)';
    } else {
        // Default: do not clip (same as clipping to the top left corner).
        this.element_.style.clip = '';
    }
};
